import {User} from '../../model/user';
import {Lens} from '../../../lenses/shared/model/lens';
import {Role} from '../../model/role';

export interface ActiveUserState {
  user: User;
  lens: Lens;
  role: Role;
  alertsCount: number;
}

export const initialActiveUserState: ActiveUserState = {
  user: null,
  lens: null,
  role: null,
  alertsCount: 0,
};
